import {logout} from "../Constants";

export const clearSession = () => {
    localStorage.setItem("profile", JSON.stringify(null));
    localStorage.setItem("stage", JSON.stringify(null));
};

const isOnSiteHome = () =>
    window.location.pathname === "/" && !window.location.search && !window.location.hash;

export const redirectToSiteHome = () => {
    if (isOnSiteHome()) {
        return;
    }
    window.location.replace("/");
};

/** End server session and return to the app (OAuth logout redirects to home). */
export const logoutAndGoHome = () => {
    clearSession();
    window.location.href = logout;
};
